import { useSocial } from '@hook'
import { yupResolver } from '@hookform/resolvers/yup'
import { socialSchema } from '@schema/pDirectory.schema'
import { DateInputField, FormButton, Modal, RadioBtn, SelectInputField, SmallText } from '@ui'
import { getError, showToast } from '@util'
import { Box, Form, Text } from 'grommet'
import { Controller, FormProvider, useForm } from 'react-hook-form'
import { useParams, useSearchParams } from 'react-router-dom'

type Props = {
  onClose: () => void
}

const socialType = ['tobacco', 'coffee', 'alcohol', 'reacreational drugs', 'counselling']

const AddSocial = ({ onClose }: Props) => {
  const { patientId, intakeId: id } = useParams()
  const methods = useForm({ resolver: yupResolver(socialSchema) })
  const { createSocial } = useSocial()
  const [searchParams] = useSearchParams()
  const intakeId = searchParams.get('intake') || id

  const onSubmit = async (data: any) => {
    const payload = {
      data: {
        attributes: {
          ...data
        },
        relationships: intakeId
          ? {
              intake: {
                data: {
                  id: intakeId,
                  type: 'intake'
                }
              },
              patient: {
                data: {
                  id: patientId,
                  type: 'patient'
                }
              }
            }
          : {
              patient: {
                data: {
                  id: patientId,
                  type: 'patient'
                }
              }
            },
        type: 'social_history'
      }
    }
    try {
      await createSocial(payload)
      showToast('Social created successfully')
      onClose()
    } catch (error) {
      getError(error)
    }
  }
  return (
    <FormProvider {...methods}>
      <Modal onClose={onClose} reset={methods.reset} title="Add Social">
        <Form
          onSubmit={methods.handleSubmit(onSubmit)}
          style={{ display: 'flex', flexDirection: 'column', overflow: 'auto' }}
        >
          <Box
            overflow={'auto'}
            pad="medium"
            style={{ display: 'block', scrollbarColor: '#fff', scrollbarWidth: 'thin' }}
          >
            <Box>
              <SmallText>Choose Social Type</SmallText>
              <Controller
                control={methods.control}
                name="social_type"
                render={({ field, fieldState: { error } }) => (
                  <>
                    <Box margin={{ top: '12px' }}>
                      {socialType?.map(list => (
                        <Box align="center" direction="row" gap={'12px'} id={list} key={list} pad={{ bottom: '15px' }}>
                          <RadioBtn {...field} checked={list === field?.value} value={list} />
                          <Text color={'black'} size="small" style={{ textTransform: 'capitalize' }}>
                            {list}
                          </Text>
                        </Box>
                      ))}
                    </Box>
                    <Box pad={{ left: 'small' }}>
                      <Text color="status-error" size="small">
                        {error?.message}
                      </Text>
                    </Box>
                  </>
                )}
              />
            </Box>
            {/* <Box>
              <FormInputField label="Name" name="social_name" />
            </Box> */}
            <Box>
              <SelectInputField label="Status" name="status" options={['Active', 'improved', 'stopped']} />
            </Box>
            <Box>
              <DateInputField label="Date" name="date" />
            </Box>
          </Box>
          <FormButton isLoading={methods.formState.isSubmitting} onClose={onClose} submit="save" />
        </Form>
      </Modal>
    </FormProvider>
  )
}

export default AddSocial
